import { useEffect, useState } from "react";
import { themeColors } from "../../Components/theme";
import { connect } from "react-redux";
import ShortLeadsRUbixLogo1 from '../../Assets/Images/shortLogoLeadsRubix1.png';
import "../../theme-vars.css";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import InputTextValue from "../../Components/TextInput/InputTextValue";
import styles from "./MyProfile.module.css";

const MyProfile = ({ user, theme }: any) => {
    const themeMUI = useTheme();
    const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
    const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        contactNumber: "",
        email: "",
        profileStatus: "",
        country: "",
        state: "",
        contactCode: "",
    });

    const [editMode, setEditMode] = useState(false);

    useEffect(() => {
        if (user) {
            setForm({
                firstName: user.user_first_name || "",
                lastName: user.user_last_name || "",
                contactNumber: user.contact_no || "",
                email: user.user_email || "",
                profileStatus: user.profile || "",
                country: user.country || "",
                state: user.state || "",
                contactCode: user.admin_contact_code || "",
            });
        }
    }, [user]);

    const handleSave = () => {
        setEditMode(false);
    };
    const handleCancel = () => {
        setEditMode(false);
    };

    return (
        <Box className={styles.parent} style={{ marginTop: isMobile ? "6%" : "4%", fontFamily: "var(--font-family-main)" }}>
            <Box
                sx={{
                    minHeight: "calc(100vh - 60px)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    px: isMobile ? 2 : 0,     // mobile padding
                    background: "transparent",
                    width: "100%",
                    fontFamily: "var(--font-family-main)",
                }}
            >
                <Box
                    sx={{
                        background: "linear-gradient(266deg, #rgb(168 171 210) 0%, #fffbe6 100%)",
                        borderRadius: 3,
                        boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
                        p: isMobile ? 2 : 5,     // responsive padding
                        maxWidth: 1100,
                        pb: isMobile ? 10 : 5, // extra bottom padding FIX ✔
                        width: "100%",
                        color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
                        fontFamily: "var(--font-family, 'Roboto', sans-serif)",
                        position: "relative",
                    }}
                >

                    {/* Header */}
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: isMobile ? "column" : "row",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: isMobile ? 2 : 1,
                            textAlign: isMobile ? "center" : "left",
                            mb: 4,
                        }}
                    >
                        <Box
                            sx={{
                                height: isMobile ? 55 : 67,
                                width: isMobile ? 55 : 67,
                                borderRadius: "50%",
                                overflow: "hidden",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <img
                                src={ShortLeadsRUbixLogo1}
                                alt="logo"
                                style={{
                                    height: "100%",
                                    width: "100%",
                                    objectFit: "cover",
                                    borderRadius: "50%",
                                }}
                            />
                        </Box>
                        <Box>
                            <Box sx={{ fontWeight: 700, fontSize: isMobile ? 18 : 22 }}>
                                {`${form.firstName} ${form.lastName}`.trim() || "Alexa Rawles"}
                            </Box>
                            <Box sx={{ color: "#888", fontSize: 14 }}>
                                {form.email || "alexarawles@gmail.com"}
                            </Box>
                        </Box>
                    </Box>

                    {/* 🟦 Responsive Grid Form */}
                    <Grid container spacing={2} sx={{ width: "100%" }}>
                        {/* Left Column */}
                        <Grid item xs={12} sm={6}>
                            <InputTextValue
                                title="First Name"
                                value={form.firstName}
                                disabled={!editMode}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        firstName: e.target.value
                                    })
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputTextValue
                                title="Last Name"
                                value={form.lastName}
                                disabled={!editMode}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        lastName: e.target.value
                                    })
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputTextValue
                                title="Email"
                                value={form.email}
                                disabled={!editMode}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        email: e.target.value
                                    })
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputTextValue
                                title="Profile Status"
                                value={form.profileStatus}
                                disabled={!editMode}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        profileStatus: e.target.value
                                    })
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputTextValue
                                title="Contact Number"
                                value={form.contactNumber}
                                disabled={!editMode}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        contactNumber: e.target.value
                                    })
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputTextValue
                                title="Country"
                                value={form.country}
                                disabled={!editMode}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        country: e.target.value
                                    })
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputTextValue
                                title="State"
                                value={form.state}
                                disabled={!editMode}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        state: e.target.value
                                    })
                                }
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Box>
    );
};

const mapStateToProps = (state: any) => {
    return {
        user: state.user.data,
        organizationUsers: state.organizationUsers.data,
        theme: state.theme.isLightMode,
        projectHeader: state.projectHeaderList.data,
        searchString: state.searchItem.projectSearchString,
    };
};

export default connect(mapStateToProps)(MyProfile);